var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { Months } from '../enums/months.enum';
import { DistributorLevel } from '../enums/distributor-level.enum';
import { CustomerService } from '../services/customer.service';
import * as moment from 'moment/moment';
import { DatePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { environment } from '../../../environments/environment';
import { ImgSrcConstants } from '../../common/constants/imgsrc.constants';
import { AppLoaderService } from '../../shared/services/app-loader.service';
import { NumberFormat } from '../../common/pipes/number-format.pipe';
import { TitleCasePipe } from '../../common/pipes/title-case.pipe';
var MydownlineReportComponent = /** @class */ (function () {
    function MydownlineReportComponent(_commonService, _localStorageService, _downline, _datePipe, _loader, _translatePipe, _decimalPipe, _currencyPipe, _numberFormatPipe, _titleCasePipe) {
        this._commonService = _commonService;
        this._localStorageService = _localStorageService;
        this._downline = _downline;
        this._datePipe = _datePipe;
        this._loader = _loader;
        this._translatePipe = _translatePipe;
        this._decimalPipe = _decimalPipe;
        this._currencyPipe = _currencyPipe;
        this._numberFormatPipe = _numberFormatPipe;
        this._titleCasePipe = _titleCasePipe;
        this.errormessage = false;
        this.countries = [];
        this.distributorId = '440100400540';
        this.months = Months;
        this.monthValues = [];
        this.recentYears = [];
        this.recentMonths = [];
        this.fboLevels = [];
        this.selectedLevels = [];
        this.levels = DistributorLevel;
        this.isOpen = true;
        this.expandingLevel = 1;
        this.level = 0;
        this.year = 0;
        this.month = 0;
        this.distributorLevel = '';
        this.sortOption = '';
        this.sortType = true; // true= ascending ; false= descending
        this.monthFlag = false;
        this.removeKeys = ['$$gtRowId'];
    }
    MydownlineReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userInfo = this._localStorageService.get('UserInfo');
        this.mydate = this._datePipe.transform(new Date(), 'dd-MMM-yyyy');
        this.userName = this.userInfo['firstName'] + ' ' + this.userInfo['lastName'];
        // this.distributorId = this.userInfo['distributorId'];
        this.homeCountryCode = 'GBR'; //localStorage.getItem('appadmin.homeCountryCode');
        this.getCountries(this.distributorId, this.homeCountryCode);
        this.getRecentMonthYear();
        this.getExportImageUrls();
        this._commonService.getTransaltedText().subscribe(function (res) {
            if (res != null) {
                _this.multiSelectSetting = {
                    singleSelection: false,
                    text: _this._translatePipe.get('ticketing-system.Select')['value'] || 'Select',
                    selectAllText: _this._translatePipe.get('mydownline.Select All')['value'] || 'Select All',
                    unSelectAllText: _this._translatePipe.get('mydownline.UnSelect All')['value'] || 'UnSelect All',
                    enableSearchFilter: true,
                    maxHeight: 150,
                    badgeShowLimit: '1',
                    classes: 'myclass custom-class'
                };
            }
            else {
                _this.multiSelectSetting = {
                    singleSelection: false,
                    text: 'Select',
                    selectAllText: 'Select All',
                    unSelectAllText: 'UnSelect All',
                    enableSearchFilter: true,
                    maxHeight: 150,
                    badgeShowLimit: '1',
                    classes: 'myclass custom-class'
                };
            }
            _this.getTranslatedFBOLevelandMonths();
        });
    };
    MydownlineReportComponent.prototype.getDownLineMemberDetail = function (distributorId, level, ownerIdorName, sortOption) {
        var _this = this;
        this._loader.show();
        this._downline.getDownLineMemberDetail(distributorId, null, this.year, this.month, this.country, this.distributorLevel, this.hideZeroCC, this.sortOption, this.expandingLevel, 0)
            .subscribe(function (res) {
            _this.data = res;
            _this._loader.hide();
            _this.isOpen = _this.data[0].downLineMembers.length == 0 ? false : true;
        }, function (error) {
            _this.errormessage = true;
        });
    };
    MydownlineReportComponent.prototype.setYear = function (year) {
        this.year = year;
    };
    MydownlineReportComponent.prototype.setMonth = function (month) {
        this.month = month;
    };
    MydownlineReportComponent.prototype.getDownlineDetailsBySortOption = function (sortOption) {
        var temp = this.sortOption.replace('-', '');
        if (temp === sortOption) {
            if (this.sortOption.indexOf('-') === -1) {
                this.sortType = false;
                this.sortOption = '-' + sortOption;
            }
            else {
                this.sortType = true;
                this.sortOption = sortOption;
            }
        }
        else {
            this.sortType = true;
            this.sortOption = sortOption;
        }
        var value = this.sortOption.includes('_') ? this.sortOption.substr(0, this.sortOption.indexOf('_')) : this.sortOption;
        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, value);
    };
    MydownlineReportComponent.prototype.getDownlineDetailsByHideZeroPersonalCC = function () {
        this.year = 0;
        this.month = 0;
        this.distributorLevel = '';
        this.expandingLevel = 1;
        this.hideZeroCC = !this.hideZeroCC;
        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
    };
    MydownlineReportComponent.prototype.expandNextLevel = function () {
        this.year = 0;
        this.month = 0;
        this.distributorLevel = '';
        this.expandingLevel = this.expandingLevel + 1;
        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
    };
    MydownlineReportComponent.prototype.getRecentMonthYear = function () {
        var currentYear = new Date().getFullYear();
        var currentMonth = new Date().getMonth() + 1;
        this.getRecentMonths(currentMonth);
        this.recentYears.push(+currentYear - 2);
        this.recentYears.push(+currentYear - 1);
        this.recentYears.push(currentYear);
    };
    MydownlineReportComponent.prototype.getRecentMonths = function (currentMonth) {
        this.recentMonths.push(moment((currentMonth - 2) === 0 ? 12 : (currentMonth - 2) === -1 ? 11 : (currentMonth - 2), 'MM' || 'M').format('MMM'));
        this.recentMonths.push(moment((currentMonth - 1) === 0 ? 12 : (currentMonth - 1), 'MM' || 'M').format('MMM'));
        this.recentMonths.push(moment(currentMonth, 'MM' || 'M').format('MMM'));
    };
    /**
     * getCountries Method used to get the country list
     * @param  {number} distributorId
     * @returns void
     */
    MydownlineReportComponent.prototype.getCountries = function (distributorId, homeCountry) {
        var _this = this;
        this._commonService
            .getCountries(distributorId, homeCountry)
            .subscribe(function (res) {
            if (res.length > 0 && res != null) {
                res.forEach(function (element) {
                    var country = { name: '', value: '' };
                    country.name = element.countryName;
                    country.value = (element.countryName.indexOf('/') > -1 ? element.countryName.replace('/', ',') : element.countryName);
                    if (element.homeCountry == true || element.homeCountry === 'true') {
                        _this.selectedCountry = _this.homeCountry = country;
                    }
                    _this.countries.push(country);
                });
                _this.country = _this.homeCountry.value !== null && _this.homeCountry.value !== undefined ? _this.homeCountry.value.substr(0, 3) : '';
                _this.getDownLineMemberDetail(_this.distributorId, _this.expandingLevel, _this.ownerIdorName, _this.sortOption);
            }
        }, function (error) {
            _this.errormessage = true;
        });
    };
    /**
     * changeCountry Method used to get the recruitment data based on country selected
     * @param  {string} country
     * @returns void
     */
    MydownlineReportComponent.prototype.changeCountry = function (country) {
        this.country = (country.indexOf('/') > -1 ? country.replace('/', ',') : country);
        this.country = this.country.substring(0, 3);
        this.year = 0;
        this.month = 0;
        this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
    };
    MydownlineReportComponent.prototype.getTranslatedFBOLevelandMonths = function () {
        var _this = this;
        var levelList = Object.keys(this.levels).map(function (k) { return _this.levels[k]; }).filter(function (v) { return typeof v === 'string'; });
        levelList.forEach(function (item) {
            _this.fboLevels.push({ id: _this._translatePipe.get('mydownline.' + item)['value'], itemName: _this._translatePipe.get('mydownline.' + item)['value'] });
        });
        var monthList = Object.keys(this.months).map(function (k) { return _this.months[k]; }).filter(function (v) { return typeof v === 'string'; });
        var id = 1;
        monthList.forEach(function (item) {
            _this.monthValues.push({ id: id, itemName: _this._translatePipe.get('mydownline.' + item)['value'] });
            id = id + 1;
        });
    };
    MydownlineReportComponent.prototype.onItemSelect = function (item) {
    };
    MydownlineReportComponent.prototype.OnItemDeSelect = function (item) {
    };
    MydownlineReportComponent.prototype.onSelectAll = function (items) {
    };
    MydownlineReportComponent.prototype.onDeSelectAll = function (items) {
    };
    MydownlineReportComponent.prototype.getDownlineByFilters = function () {
        var _this = this;
        this.distributorLevel = '';
        this.expandingLevel = 1;
        var currentMonth = new Date().getMonth() + 1;
        var currentYear = new Date().getFullYear();
        if (this.month == 0) {
            this.recentMonths = [];
            this.getRecentMonths(currentMonth);
        }
        else {
            this.recentMonths = [];
            this.getRecentMonths(this.month);
        }
        if (+this.year == currentYear && +this.month > currentMonth) {
            this.monthFlag = true;
        }
        else {
            this.monthFlag = false;
            this.selectedLevels.forEach(function (element) {
                _this.distributorLevel = _this.distributorLevel + " " + element.itemName + ",";
            });
            this.distributorLevel = this.distributorLevel.substr(0, this.distributorLevel.length - 1);
            if (this.ownerIdorName !== null && this.ownerIdorName !== undefined && this.ownerIdorName.toString() !== '') {
                this.getDownLineMemberDetail(this.ownerIdorName, this.expandingLevel, this.ownerIdorName, this.sortOption);
            }
            else {
                this.getDownLineMemberDetail(this.distributorId, this.expandingLevel, this.ownerIdorName, this.sortOption);
            }
        }
    };
    /**
   * downloadExcel Method used to create the excel file
   * @returns void
   */
    MydownlineReportComponent.prototype.downloadExcel = function () {
        var data = [];
        data = this.prepareExcelData(this.data, false);
        var ws = XLSX.utils.json_to_sheet(data);
        /* generate workbook and add the worksheet */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        /* save to file */
        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout]), this._translatePipe.get('mydownline.My Downline Volume')['value'] + '.xlsx');
    };
    MydownlineReportComponent.prototype.getTranslatedMonth = function (month) {
        return this._translatePipe.get('common.' + month)['value'];
    };
    MydownlineReportComponent.prototype.prepareExcelData = function (downlineData, flag) {
        var _this = this;
        var data = [];
        var mydownlineData;
        downlineData.forEach(function (element) {
            mydownlineData = {
                name: element['name'],
                gen: element['generation'],
                id: element['distributorFormatedId'],
                title: element['level'],
                country: element['country'],
                sponsorDate: element['sponsorDate'],
                phone: element['phone'],
                email: element['email'],
                activeCCMonthOne: element['active'].monthOne,
                activeCCMonthTwo: element['active'].monthTwo,
                activeCCMonthThree: element['active'].monthThree,
                personalCCMonthOne: (element['personalCC'].monthOne === null ? '0.0' : element['personalCC'].monthOne),
                personalCCMonthTwo: (element['personalCC'].monthTwo === null ? '0.0' : element['personalCC'].monthTwo),
                personalCCMonthThree: (element['personalCC'].monthThree === null ? '0.0' : element['personalCC'].monthThree),
                totalCCMonthOne: (element['totalCC'].monthOne === null ? '0.0' : element['totalCC'].monthOne),
                totalCCMonthTwo: (element['totalCC'].monthTwo === null ? '0.0' : element['totalCC'].monthTwo),
                totalCCMonthThree: (element['totalCC'].monthThree === null ? '0.0' : element['totalCC'].monthThree),
                totalGlobalCCYTD: element['totalGlobalCCYTD'],
                totalActiveCCMonthOne: (element['totalActiveCC'].monthOne === null ? '0.0' : element['totalActiveCC'].monthOne),
                totalActiveCCMonthTwo: (element['totalActiveCC'].monthTwo === null ? '0.0' : element['totalActiveCC'].monthTwo),
                totalActiveCCMonthThree: (element['totalActiveCC'].monthThree === null ? '0.0' : element['totalActiveCC'].monthThree),
                totalActiveCCYTD: (element['totalActiveCC'].ytd === null ? '0.0' : element['totalActiveCC'].ytd),
                nonManagerCCMonthOne: (element['nonManagerCC'].monthOne === null ? '0.0' : element['nonManagerCC'].monthOne),
                nonManagerCCMonthTwo: (element['nonManagerCC'].monthTwo === null ? '0.0' : element['nonManagerCC'].monthTwo),
                nonManagerCCMonthThree: (element['nonManagerCC'].monthThree === null ? '0.0' : element['nonManagerCC'].monthThree),
                nonManagerCCYTD: (element['nonManagerCC'].ytd === null ? '0.0' : element['nonManagerCC'].ytd),
                leadershipCCMonthOne: (element['leadershipCC'].monthOne === null ? '0.0' : element['leadershipCC'].monthOne),
                leadershipCCMonthTwo: (element['leadershipCC'].monthTwo === null ? '0.0' : element['leadershipCC'].monthTwo),
                leadershipCCMonthThree: (element['leadershipCC'].monthThree === null ? '0.0' : element['leadershipCC'].monthThree),
                leadershipCCYTD: (element['leadershipCC'].ytd === null ? '0.0' : element['leadershipCC'].ytd),
                newEagleManagerGlobalCC: element['newEagleManagerGlobalCC'],
                newChairmansBonusGlobalCC: element['newChairmansBonusGlobalCC']
            };
            data.push(_this.getTranslatedData(_this.removeKeys, mydownlineData));
            if (element['hasDownLine'] === true && element['downLineMembers'].length > 0) {
                var temp = _this.prepareExcelData(element['downLineMembers'], true);
                data = data.concat(temp);
            }
        });
        return data;
    };
    /**
 * prepareExcelData Method used to prepare the data to be exported to excel file by removing unwanted columns
 * @param  {any} keys
 * @param  {any} data
 * @returns object
 */
    MydownlineReportComponent.prototype.getTranslatedData = function (keys, data) {
        var _this = this;
        var exportData = Object.keys(data).reduce(function (obj, key) {
            if (keys.indexOf(key) === -1) {
                if (key == 'name') {
                    key = _this._translatePipe.get('common.Name')['value'] || 'Name';
                    return __assign({}, obj, (_a = {}, _a[key] = (data['name']), _a));
                }
                else if (key == 'gen') {
                    key = _this._translatePipe.get('mydownline.Generation')['value'] || 'Generation';
                    return __assign({}, obj, (_b = {}, _b[key] = (data['gen']), _b));
                }
                else if (key == 'level') {
                    key = _this._translatePipe.get('mydownline.Title')['value'] || 'Title';
                    return __assign({}, obj, (_c = {}, _c[key] = (data['level']), _c));
                }
                else if (key == 'country') {
                    key = _this._translatePipe.get('common.Country')['value'] || 'Country';
                    return __assign({}, obj, (_d = {}, _d[key] = (data['country']), _d));
                }
                else if (key == 'sponsorDate') {
                    key = _this._translatePipe.get('mydownline.Sponsor Date')['value'] || 'Sponsor Date';
                    return __assign({}, obj, (_e = {}, _e[key] = (data['sponsorDate']), _e));
                }
                else if (key == 'phone') {
                    key = _this._translatePipe.get('mydownline.Phone')['value'] || 'Phone';
                    return __assign({}, obj, (_f = {}, _f[key] = (data['phone']), _f));
                }
                else if (key == 'email') {
                    key = _this._translatePipe.get('common.Email')['value'] || 'Email';
                    return __assign({}, obj, (_g = {}, _g[key] = (data['email']), _g));
                }
                else if (key == 'id') {
                    key = _this._translatePipe.get('mydownline.FBO ID')['value'] || 'FBO ID';
                    return __assign({}, obj, (_h = {}, _h[key] = (data['id']), _h));
                }
                else if (key == 'newEagleManagerGlobalCC') {
                    key = _this._translatePipe.get('mydownline.New Eagle Manager')['value'] + ' ' + _this._translatePipe.get('mydownline.Global CC')['value'] || 'New Eagle Manager Global CC';
                    return __assign({}, obj, (_j = {}, _j[key] = (data['newEagleManagerGlobalCC']), _j));
                }
                else if (key == 'newChairmansBonusGlobalCC') {
                    key = _this._translatePipe.get('mydownline.New Chairmans Bonus')['value'] + ' ' + _this._translatePipe.get('mydownline.Global CC')['value'] || 'New Chairmans Bonus Global CC';
                    return __assign({}, obj, (_k = {}, _k[key] = (data['newChairmansBonusGlobalCC']), _k));
                }
                else if (key == 'activeCCMonthOne') {
                    key = _this._translatePipe.get('common.Active')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[0]) || 'Active - ' + _this.recentMonths[0];
                    return __assign({}, obj, (_l = {}, _l[key] = (data['activeCCMonthOne']), _l));
                }
                else if (key == 'activeCCMonthTwo') {
                    key = _this._translatePipe.get('common.Active')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[1]) || 'Active - ' + _this.recentMonths[1];
                    return __assign({}, obj, (_m = {}, _m[key] = (data['activeCCMonthTwo']), _m));
                }
                else if (key == 'activeCCMonthThree') {
                    key = _this._translatePipe.get('common.Active')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[2]) || 'Active - ' + _this.recentMonths[2];
                    return __assign({}, obj, (_o = {}, _o[key] = (data['activeCCMonthThree']), _o));
                }
                else if (key == 'personalCCMonthOne') {
                    key = _this._translatePipe.get('common.Personal CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[0]) || 'Personal CC - ' + _this.recentMonths[0];
                    return __assign({}, obj, (_p = {}, _p[key] = (data['personalCCMonthOne']), _p));
                }
                else if (key == 'personalCCMonthTwo') {
                    key = _this._translatePipe.get('common.Personal CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[1]) || 'Personal CC - ' + _this.recentMonths[1];
                    return __assign({}, obj, (_q = {}, _q[key] = (data['personalCCMonthTwo']), _q));
                }
                else if (key == 'personalCCMonthThree') {
                    key = _this._translatePipe.get('common.Personal CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[2]) || 'Personal CC - ' + _this.recentMonths[2];
                    return __assign({}, obj, (_r = {}, _r[key] = (data['personalCCMonthThree']), _r));
                }
                else if (key == 'totalCCMonthOne') {
                    key = _this._translatePipe.get('common.Total CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[0]) || 'Total CC - ' + _this.recentMonths[0];
                    return __assign({}, obj, (_s = {}, _s[key] = (data['totalCCMonthOne']), _s));
                }
                else if (key == 'totalCCMonthTwo') {
                    key = _this._translatePipe.get('common.Total CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[1]) || 'Total CC - ' + _this.recentMonths[1];
                    return __assign({}, obj, (_t = {}, _t[key] = (data['totalCCMonthTwo']), _t));
                }
                else if (key == 'totalCCMonthThree') {
                    key = _this._translatePipe.get('common.Total CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[2]) || 'Total CC - ' + _this.recentMonths[2];
                    return __assign({}, obj, (_u = {}, _u[key] = (data['totalCCMonthThree']), _u));
                }
                else if (key == 'totalGlobalCCYTD') {
                    key = _this._translatePipe.get('mydownline.Total Global CC')['value'] + _this._translatePipe.get('mydownline.YTD')['value'] || 'Total Global CC YTD';
                    return __assign({}, obj, (_v = {}, _v[key] = (data['totalGlobalCCYTD']), _v));
                }
                else if (key == 'totalActiveCCMonthOne') {
                    key = _this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[0]) || 'Total Active CC - ' + _this.recentMonths[0];
                    return __assign({}, obj, (_w = {}, _w[key] = (data['totalActiveCCMonthOne']), _w));
                }
                else if (key == 'totalActiveCCMonthTwo') {
                    key = _this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[1]) || 'Total Active CC - ' + _this.recentMonths[1];
                    return __assign({}, obj, (_x = {}, _x[key] = (data['totalActiveCCMonthTwo']), _x));
                }
                else if (key == 'totalActiveCCMonthThree') {
                    key = _this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[2]) || 'Total Active CC - ' + _this.recentMonths[2];
                    return __assign({}, obj, (_y = {}, _y[key] = (data['totalActiveCCMonthThree']), _y));
                }
                else if (key == 'totalActiveCCYTD') {
                    key = _this._translatePipe.get('common.Total Active CC')['value'] + ' - ' + _this._translatePipe.get('mydownline.YTD')['value'] || 'Total Active CC - YTD';
                    return __assign({}, obj, (_z = {}, _z[key] = (data['totalActiveCCYTD']), _z));
                }
                else if (key == 'nonManagerCCMonthOne') {
                    key = _this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[0]) || 'Non-Manager CC - ' + _this.recentMonths[0];
                    return __assign({}, obj, (_0 = {}, _0[key] = (data['nonManagerCCMonthOne']), _0));
                }
                else if (key == 'nonManagerCCMonthTwo') {
                    key = _this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[1]) || 'Non-Manager CC - ' + _this.recentMonths[1];
                    return __assign({}, obj, (_1 = {}, _1[key] = (data['nonManagerCCMonthTwo']), _1));
                }
                else if (key == 'nonManagerCCMonthThree') {
                    key = _this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[2]) || 'Non-Manager CC - ' + _this.recentMonths[2];
                    return __assign({}, obj, (_2 = {}, _2[key] = (data['nonManagerCCMonthThree']), _2));
                }
                else if (key == 'nonManagerCCYTD') {
                    key = _this._translatePipe.get('common.Non-Manager CC')['value'] + ' - ' + _this._translatePipe.get('mydownline.YTD')['value'] || 'Non-Manager CC - YTD';
                    return __assign({}, obj, (_3 = {}, _3[key] = (data['nonManagerCCYTD']), _3));
                }
                else if (key == 'leadershipCCMonthOne') {
                    key = _this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[0]) || 'Leadership CC - ' + _this.recentMonths[0];
                    return __assign({}, obj, (_4 = {}, _4[key] = (data['leadershipCCMonthOne']), _4));
                }
                else if (key == 'leadershipCCMonthTwo') {
                    key = _this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[1]) || 'Leadership CC - ' + _this.recentMonths[1];
                    return __assign({}, obj, (_5 = {}, _5[key] = (data['leadershipCCMonthTwo']), _5));
                }
                else if (key == 'leadershipCCMonthThree') {
                    key = _this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + _this.getTranslatedMonth(_this.recentMonths[2]) || 'Leadership CC - ' + _this.recentMonths[2];
                    return __assign({}, obj, (_6 = {}, _6[key] = (data['leadershipCCMonthThree']), _6));
                }
                else if (key == 'leadershipCCYTD') {
                    key = _this._translatePipe.get('mydownline.Leadership CC')['value'] + ' - ' + _this._translatePipe.get('mydownline.YTD')['value'] || 'Leadership CC - YTD';
                    return __assign({}, obj, (_7 = {}, _7[key] = (data['leadershipCCYTD']), _7));
                }
                else {
                    return __assign({}, obj, (_8 = {}, _8[key] = data[key], _8));
                }
            }
            return obj;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
        }, {});
        return exportData;
    };
    /**
     * getExportImageUrls Method used to get the image source path for Exports
     * @returns void
     */
    MydownlineReportComponent.prototype.getExportImageUrls = function () {
        if (process.env.ENV === 'production') {
            //   this.pdfImageUrl =environment.baseHref + '/resources/static/' + ImgSrcConstants.exportImgUrl + 'pdf' + '.ico';
            this.excelImageUrl = environment.baseHref + '/resources/static/' + ImgSrcConstants.exportImgUrl + 'excel' + '.ico';
        }
        else {
            //   this.pdfImageUrl =environment.baseHref + ImgSrcConstants.exportImgUrl + 'pdf' + '.ico';
            this.excelImageUrl = environment.baseHref + ImgSrcConstants.exportImgUrl + 'excel' + '.ico';
        }
    };
    return MydownlineReportComponent;
}());
export { MydownlineReportComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/downline-report.component.ts.pre-build-optimizer.js